const getCSSValue = (variableName: string): string =>
	window.getComputedStyle(document.body).getPropertyValue(variableName);

export const colors = {
	// Primary
	primary: getCSSValue("--primary-color"),
	primaryDark: getCSSValue("--primary-dark"),
	primaryDark50: getCSSValue("--primary-dark-50"),
	primary25: getCSSValue("--primary-25"),
	primary10: getCSSValue("--primary-10"),
	primaryBackground: getCSSValue("--primary-background"),

	// Secondary
	validation: getCSSValue("--validation"),
	validationDark: getCSSValue("--validation-dark"),
	validation25: getCSSValue("--validation-25"),
	validation10: getCSSValue("--validation-10"),
	rejection: getCSSValue("--rejection"),
	rejectionDark: getCSSValue("--rejection-dark"),
	rejection25: getCSSValue("--rejection-25"),
	rejection10: getCSSValue("--rejection-10"),
	warn: getCSSValue("--warn"),
	warnDark: getCSSValue("--warn-dark"),

	// Greyscale
	black: getCSSValue("--black"),
	grey: getCSSValue("--grey"),
	grey80: getCSSValue("--grey-80"),
	grey50: getCSSValue("--grey-50"),
	grey25: getCSSValue("--grey-25"),
	grey10: getCSSValue("--grey-10"),
	grey5: getCSSValue("--grey-5"),
	grey3: getCSSValue("--grey-3"),
	white: getCSSValue("--white"),
	neutral10: getCSSValue("--neutral-10"),

	// Colors outside of Design System
	orange: "#ff8214",
	yellow: "#FFAF00",
	transparent: "transparent",
	videoBackground: "#eae8fA",
	mobilePrimaryBlue: "#5500ff",
	mobilePrimaryBlue50: "#AA80FF",
	mobilePrimaryBlue15: "#E1D2FF",
	mobileDarkPrimaryBlue: "#330099",
	demoRequestBlue: "#00C3E6",
	onboardingPrimary: "#A055F0",
	onboardingPrimaryDark: "#603390",
	primary75: "#7279EB", // TODO: Add to Prime React Designer
} as const;
